import styled from "styled-components";

export const BottomContainer = styled.div`
    height: 20vh;
    overflow: hidden;
`

export const OutSider = styled.div`
    height: 20vh;
    width: 100%;
    background: black;
`